import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { GraphCSVProps } from "../../../wrappers/LoadingGraph";

export const headers = [
  {
    label: "Year Week",
    key: "yearweek",
  },
  {
    label: "Ads",
    key: "ads",
  },
];

const AdsOver90DaysCSV = ({ data }: GraphCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default AdsOver90DaysCSV;
